import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';
import { SnackbarKey, VariantType } from 'notistack';

import { createNotification } from 'hooks';
import { RootState, NotificationsState } from 'store';

const initialState: NotificationsState = {
  notifications: [],
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification(state, { payload }: PayloadAction<{ message: string; type: VariantType }>) {
      if (payload.message) {
        state.notifications.push(castDraft(createNotification(payload.message, payload.type)));
      }
    },
    closeNotification(state, { payload }: PayloadAction<SnackbarKey>) {
      state.notifications = state.notifications.map((notification) => {
        return notification.key === payload ? { ...notification, dismissed: true } : { ...notification };
      });
    },
    removeNotification(state, { payload }: PayloadAction<SnackbarKey>) {
      state.notifications = state.notifications.filter((notification) => notification.key !== payload);
    },
  },
});

export const {
  actions: { addNotification, closeNotification, removeNotification },
  reducer: notificationsReducer,
} = notificationsSlice;

export const getNotifications = ({ notifications }: RootState) => notifications.notifications;
